import Worker from 'worker-loader!./run-simulations.worker.js';
import FiveCardHands from '@/services/five-card-hands/FiveCardHands';

export default {
  getEquities: function (weightedRanges, presetCommunityCardsArray, numberOfSimulations, progressCb) {
    return new Promise(function (resolve, reject) {
      let worker = new Worker();

      worker.onmessage = function (e) {
        if (e.data.message === 'progress') {
          progressCb(e.data.value);
        }

        else if (e.data.message === 'finished') {
          worker.terminate();
          resolve(e.data.simulationResults);
        }

        else if (e.data.message === 'error') {
          worker.terminate();
          reject(e.data.error);
        }
      };
      worker.postMessage({
        message: 'calculate equity',
        weightedRanges: weightedRanges,
        presetCommunityCardsArray: presetCommunityCardsArray,
        numberOfSimulations: numberOfSimulations,
      });
    });
  },

  getFlopFiveCardHandPercentages: function (players, presetCommunityCards, shortDeck) {
    if (!presetCommunityCards.flopSet) {
      throw new Error('Trying to run getFlopFiveCardHandPercentages when the flop isn\'t set.');
    }

    return this._getFiveCardHandPercentagesForPlayers(players, 1, presetCommunityCards.flopArray, shortDeck);
  },
  getTurnFiveCardHandPercentages: function (players, presetCommunityCards, shortDeck) {
    if (!presetCommunityCards.turnSet) {
      throw new Error('Trying to run getTurnFiveCardHandPercentages when the turn isn\'t set.');
    }

    return this._getFiveCardHandPercentagesForPlayers(players, 2, presetCommunityCards.turnArray, shortDeck);
  },
  getRiverFiveCardHandPercentages: function (players, presetCommunityCards, shortDeck) {
    if (!presetCommunityCards.riverSet) {
      throw new Error('Trying to run getRiverFiveCardHandPercentages when the river isn\'t set.');
    }

    return this._getFiveCardHandPercentagesForPlayers(players, 3, presetCommunityCards.riverArray, shortDeck);
  },
  _getFiveCardHandPercentagesForPlayers: function (players, playerStateIndex, presetCommunityCardsArray, shortDeck) {
    players.forEach(function (player) {
      this.__getFiveCardHandPercentagesForPlayer(
        player.states[playerStateIndex].fiveCardHands,
        player.states[playerStateIndex].generalHands,
        presetCommunityCardsArray,
        shortDeck
      );
    }, this);
    return Promise.resolve(); // so we can call .then
  },
  __getFiveCardHandPercentagesForPlayer: function (fiveCardHands, generalHands, presetCommunityCardsArray, shortDeck) {
    fiveCardHands.setMatchingSpecificHands(generalHands, presetCommunityCardsArray, shortDeck);
    fiveCardHands.setProbabilitiesAccordingToMatchingSpecificHands(generalHands);
    fiveCardHands.setPercentagesOfSpecificHandsThatAreSelected(generalHands);
  },

  getFlopFiveCardHandPercentagesViaSimulations: function (weightedRange, presetCommunityCardsArray, numberOfSimulations, progressCb) {
    return this._getFiveCardHandPercentagesViaSimulations(weightedRange, presetCommunityCardsArray, 'flop', numberOfSimulations, progressCb);
  },
  getTurnFiveCardHandPercentagesViaSimulations: function (weightedRange, presetCommunityCardsArray, numberOfSimulations, progressCb) {
    return this._getFiveCardHandPercentagesViaSimulations(weightedRange, presetCommunityCardsArray, 'turn', numberOfSimulations, progressCb);
  },
  getRiverFiveCardHandPercentagesViaSimulations: function (weightedRange, presetCommunityCardsArray, numberOfSimulations, progressCb) {
    return this._getFiveCardHandPercentagesViaSimulations(weightedRange, presetCommunityCardsArray, 'river', numberOfSimulations, progressCb);
  },
  _getFiveCardHandPercentagesViaSimulations: function (weightedRange, presetCommunityCardsArray, streetToSimulateTo, numberOfSimulations, progressCb) {
    return this.__getFiveCardHandPercentagesViaSimulations({
      message: 'get five card hand percentages via simulations',
      weightedRange: weightedRange,
      presetCommunityCardsArray: presetCommunityCardsArray,
      streetToSimulateTo: streetToSimulateTo,
      numberOfSimulations: numberOfSimulations,
    }, progressCb);
  },
  __getFiveCardHandPercentagesViaSimulations: function (payload, progressCb) {
    return new Promise(function (resolve, reject) {
      let worker = new Worker();
      let workerPayload = {
        message: payload.message,
        weightedRange: payload.weightedRange,
        presetCommunityCardsArray: payload.presetCommunityCardsArray,
        streetToSimulateTo: payload.streetToSimulateTo,
        numberOfSimulations: payload.numberOfSimulations,
      };

      worker.postMessage(workerPayload);
      worker.onmessage = function (e) {
        if (e.data.message === 'progress') {
          progressCb(e.data.value);
        }

        else if (e.data.message === 'finished') {
          worker.terminate();
          resolve(e.data.handAndDrawInfo);
        }

        else if (e.data.message === 'error') {
          worker.terminate();
          reject(e.data.error);
        }
      };
    });
  },

  getShortDeckEquities: function (weightedRanges, presetCommunityCardsArray, numberOfSimulations, progressCb) {
    return new Promise(function (resolve, reject) {
      let worker = new Worker();

      worker.onmessage = function (e) {
        if (e.data.message === 'progress') {
          progressCb(e.data.value);
        }

        else if (e.data.message === 'finished') {
          worker.terminate();
          resolve(e.data.simulationResults);
        }

        else if (e.data.message === 'error') {
          worker.terminate();
          reject(e.data.error);
        }
      };
      worker.postMessage({
        message: 'calculate short deck equity',
        weightedRanges: weightedRanges,
        presetCommunityCardsArray: presetCommunityCardsArray,
        numberOfSimulations: numberOfSimulations,
      });
    });
  },

  getFlopFiveCardHandPercentagesViaShortDeckSimulations: function (weightedRange, presetCommunityCardsArray, numberOfSimulations, progressCb) {
    return this._getFiveCardHandPercentagesViaShortDeckSimulations(weightedRange, presetCommunityCardsArray, 'flop', numberOfSimulations, progressCb);
  },
  getTurnFiveCardHandPercentagesViaShortDeckSimulations: function (weightedRange, presetCommunityCardsArray, numberOfSimulations, progressCb) {
    return this._getFiveCardHandPercentagesViaShortDeckSimulations(weightedRange, presetCommunityCardsArray, 'turn', numberOfSimulations, progressCb);
  },
  getRiverFiveCardHandPercentagesViaShortDeckSimulations: function (weightedRange, presetCommunityCardsArray, numberOfSimulations, progressCb) {
    return this._getFiveCardHandPercentagesViaShortDeckSimulations(weightedRange, presetCommunityCardsArray, 'river', numberOfSimulations, progressCb);
  },
  _getFiveCardHandPercentagesViaShortDeckSimulations: function (weightedRange, presetCommunityCardsArray, streetToSimulateTo, numberOfSimulations, progressCb) {
    return this.__getFiveCardHandPercentagesViaShortDeckSimulations({
      message: 'get five card hand percentages via short deck simulations',
      weightedRange: weightedRange,
      presetCommunityCardsArray: presetCommunityCardsArray,
      streetToSimulateTo: streetToSimulateTo,
      numberOfSimulations: numberOfSimulations,
    }, progressCb);
  },
  __getFiveCardHandPercentagesViaShortDeckSimulations: function (payload, progressCb) {
    return new Promise(function (resolve, reject) {
      let worker = new Worker();
      let workerPayload = {
        message: payload.message,
        weightedRange: payload.weightedRange,
        presetCommunityCardsArray: payload.presetCommunityCardsArray,
        streetToSimulateTo: payload.streetToSimulateTo,
        numberOfSimulations: payload.numberOfSimulations,
      };

      worker.postMessage(workerPayload);
      worker.onmessage = function (e) {
        if (e.data.message === 'progress') {
          progressCb(e.data.value);
        }

        else if (e.data.message === 'finished') {
          worker.terminate();
          resolve(e.data.handAndDrawInfo);
        }

        else if (e.data.message === 'error') {
          worker.terminate();
          reject(e.data.error);
        }
      };
    });
  },
};



// WEBPACK FOOTER //
// ./src/services/simulator/simulator.js